import { defineMaterial, type MaterialComponentProps } from '@h5/schema';
import { ShapePropsSchema, type ShapeProps } from './schema';

export { ShapePropsSchema, type ShapeProps };

/** 形状物料：纯 CSS 实现。line 用高度等于描边宽的 div，垂直居中于图层。 */
function ShapeView({ props }: MaterialComponentProps<ShapeProps>) {
  if (props.shape === 'line') {
    const h = Math.max(1, props.strokeWidth || 1);
    return (
      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
        <div style={{ width: '100%', height: h, background: props.stroke }} />
      </div>
    );
  }
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        background: props.fill,
        border: props.strokeWidth > 0 ? `${props.strokeWidth}px solid ${props.stroke}` : 'none',
        borderRadius: props.shape === 'circle' ? '50%' : props.radius,
      }}
    />
  );
}

export const shapeMaterial = defineMaterial<ShapeProps>({
  id: 'shape',
  version: 1,
  name: '形状',
  category: 'basic',
  icon: '◼',
  defaultSize: { w: 120, h: 120 },
  defaultProps: ShapePropsSchema.parse({}),
  propsSchema: ShapePropsSchema,
  component: ShapeView,
});
